export default "__VITE_ASSET__DHi$2FUP__"